export function formatValueForCsv(value: number, formatter: Intl.NumberFormat): string {
    let result = '';
    if (!value && value !== 0) {
        result = '-';
    } else {
        const parts = formatter.formatToParts(value);
        parts.forEach(part => {
            switch (part.type) {
                case 'minusSign':
                case 'integer':
                case 'decimal':
                case 'fraction':
                    result += part.value;
                    break;
            }
        });
    }
    return result;
}